exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-stock-fail .modal-container {\n  width: 700px;\n  max-width: 90vw;\n}\n.modal-stock-fail .stock-fail-list {\n  list-style: disc;\n  padding-left: 1.5rem;\n  max-height: 40vh;\n  overflow-y: auto;\n  text-align: left;\n}\n.modal-stock-fail .stock-fail-list li {\n  margin-bottom: 0.5rem;\n  line-height: 1.4;\n}\n.modal-stock-fail .stock-fail-list .stock-fail-sku {\n  font-weight: 600;\n}\n", ""]);

// exports
